import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {OAuthService} from "angular-oauth2-oidc";
import {UserProfileService} from "@services/user-profile.service";
import {AuthService} from "../auth/auth.service";
import {ProfileType} from "@variables/profileType";

const LOGIN_URL: string = '/login';

export const checkProfileGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const profileAuthorized: any[] = [...(route?.data?.profileAuthorized || [])];
  const router: Router = inject(Router);
  const oauthService: OAuthService = inject(OAuthService);
  const userProfile: UserProfileService = inject(UserProfileService);
  const authService: AuthService = inject(AuthService);

  /** Not authenticated, redirecting and adding redirect url */
  if (!oauthService.hasValidAccessToken()) {
    authService.logOut();
    router.navigateByUrl(LOGIN_URL)
    return false;
  }

  if (profileAuthorized.length === 0 || (!profileAuthorized.includes(ProfileType.ALL_PROFILES) && !profileAuthorized.includes(userProfile.getUserProfile()))) {
    router.navigateByUrl(authService.getUrlUnAuthorized());
    return false;
  }

  return true;
}
